import { render, staticRenderFns } from "./external_glovo.vue?vue&type=template&id=188e4bd1&scoped=true&"
import script from "./external_glovo.vue?vue&type=script&lang=js&"
export * from "./external_glovo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188e4bd1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('188e4bd1')) {
      api.createRecord('188e4bd1', component.options)
    } else {
      api.reload('188e4bd1', component.options)
    }
    module.hot.accept("./external_glovo.vue?vue&type=template&id=188e4bd1&scoped=true&", function () {
      api.rerender('188e4bd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/glovo/external_glovo/external_glovo.vue"
export default component.exports